import Main from 'src/components/Main.vue'
// import Main_alive from 'src/components/Main-alive.vue'
// import Main_blank from 'src/components/Main-blank.vue'
import index from 'src/views/frontStage/Index.vue'

// 首页
import dashboard from 'src/views/frontStage/page-dashboard.vue'

// 任务模块部分
import startTask from 'src/views/frontStage/task/page-start.vue'
import dealingTask from 'src/views/frontStage/task/page-dealing.vue'
import endTask from 'src/views/frontStage/task/page-end.vue'
import taskDetail from 'src/views/frontStage/task/page-detailTask.vue'

// 文档管理
import documentManage from 'src/views/frontStage/documentManage/page-docMange.vue'
import docListTpl from 'src/views/frontStage/documentManage/page-docList.vue'

// bu 管理
import ClerkManage from 'src/views/frontStage/buManage/page-personManage.vue'
import AssetDetails from 'src/views/frontStage/buManage/page-assets.vue'
import bonusTable from 'src/views/frontStage/buManage/page-bonusTable.vue'
import budgetTable from 'src/views/frontStage/buManage/page-budgetTable.vue'
import rankTable from 'src/views/frontStage/buManage/page-rankTable.vue'
import fadanTable from 'src/views/frontStage/buManage/page-ticketTable.vue'

// 个人财务
import personalBonus from 'src/views/frontStage/person/page-personalBonus.vue'
import personalTicket from 'src/views/frontStage/person/page-personalTicket.vue'

// 我的申请
import myApplication from 'src/views/frontStage/page-my-application.vue'

//审核管理
import taskExamine from 'src/views/frontStage/examine/page-task-examine.vue'
import financeExamine from 'src/views/frontStage/examine/page-finance-examine.vue'
import personnelExamine from 'src/views/frontStage/examine/page-personnel-examine.vue'

// 历史消息
import infoHistory from 'src/views/frontStage/page-info-history.vue'

export default {
    path: '/',
    component: index,
    topNav: true,
    children: [
        {
            path: 'dashboard',
            name: 'dashboard',
            text: 'busys',
            component: dashboard,
        },
        {
            path:'history-info',  
            name:'infoHistory',
            text:'历史消息',
            component:infoHistory,
        },
        {
            path: 'task',
            text: '任务管理',
            icon: 'icon-task.svg',
            component: Main,
            meta:{code:1000},
            children: [
                {
                    path: 'start-task',
                    name: 'start-task',
                    text: '发布任务',
                    component: startTask,
                    meta:{code:1010},
                    secondMenu: true,
                },
                {
                    path: 'dealing-task',
                    name: 'dealing-task',
                    text: '处理任务',
                    component: dealingTask,
                    meta:{code:1020},
                    secondMenu: true,
                },
                {
                    path: 'end-task',
                    name: 'end-task',
                    text: '终止任务',
                    component: endTask,
                    meta:{code:1030},
                    secondMenu: true,
                },
                {
                    path:"detail-task/:task_id",
                    name:"task-detail",
                    text:"任务详情",
                    component:taskDetail,
                },   
            ]

        },
        {
            path: 'finance',
            text: '个人财务',
            icon: 'icon-finance.svg',
            component: Main,
            meta:{code:1100},
            children: [
                {
                    path: 'personal-bonus',
                    name: 'personal-bonus',
                    text: '个人奖金',
                    component: personalBonus,
                    meta:{code:1110},
                    secondMenu: true,
                },
                {
                    path: 'personal-ticket',
                    name: 'personal-ticket',
                    text: '个人罚单',
                    component: personalTicket,
                    meta:{code:1120},
                    secondMenu: true,
                }
            ]
        },
        {
            path: 'document-manage',
            name: 'document-manage',
            text: '文档管理',
            icon: 'icon-doc.svg',
            redirect: { name: 'document-all' },
            component: Main,
            meta:{code:1200},
            children:[
                {   
                    path: 'list',
                    name: 'document-all',
                    component:documentManage,
                },
                {
                    path: ':type/:id',
                    name: 'document-list',
                    text: '文档详情列表',
                    component: docListTpl,
                },
            ]
        },
        
        {
            path: 'bu',
            text: 'BU管理',
            icon: 'icon-bu.svg',
            component: Main,
            meta:{code:1300},
            children: [
                {
                    path: 'worker-manage',
                    name: 'worker-manage',
                    text: 'BU与职员',
                    component: ClerkManage,
                    meta:{code:1310},
                    secondMenu: true,
                },
                {
                    path: 'info-money',
                    name: 'info-money',
                    text: 'BU资产',
                    component: AssetDetails,
                    meta:{code:1320},
                    secondMenu: true,
                },
                {
                    path: 'info-money/bu-bonus-detail',
                    name: 'bu-bonus-detail',
                    text: 'BU奖金明细',
                    component: bonusTable,
                },
                {
                    path: 'info-money/bu-pmt-detail',
                    name: 'bu-pmt-detail',
                    text: 'BU职级明细',
                    component: rankTable,
                },
                {
                    path: 'info-money/bu-budget-detail',
                    name: 'bu-budget-detail',
                    text: 'BU预算明细',
                    component: budgetTable,
                },
                {
                    path: 'info-money/bu-ticket-detail',
                    name: 'bu-ticket-detail',
                    text: 'BU罚单明细',
                    component: fadanTable,
                },
            ]

        },
        {
            path:"my-application",
            name:"my-app",
            text:"我的申请",
            icon:"icon-application.svg",
            redirect: { name: 'my-application' },
            component: Main,
            meta:{code:1400},
            children:[
                {
                    path:"detail",
                    name:"my-application",
                    component:myApplication,
                }
            ],
        },
        {
            path: 'examine',
            text: '审核管理',
            icon: 'icon-examine.svg',
            component: Main,
            meta:{code:1500},
            children:[
                {
                    path: 'task-examine',
                    name: 'task-examine',
                    text: '任务审核',
                    component: taskExamine,
                    meta:{code:1510},
                    secondMenu: true,
                },{
                    path: 'finance-examine',
                    name: 'finance-examine',
                    text: '财务审核',
                    component: financeExamine,
                    meta:{code:1520},
                    secondMenu: true,
                },{
                    path: 'personnel-examine',
                    name: 'personnel-examine',
                    text: '人事审核',
                    component: personnelExamine,
                    meta:{code:1530},
                    secondMenu: true,
                }
                
            ]
        },
    ]

}



// WEBPACK FOOTER //
// ./src/config/router-front-config.js